import { UseQueryOptions } from 'react-query';
import { KeyValueResponse } from '../model';
import { ServiceError } from '../../hooks/error';
import { useCustomQuery } from '../../hooks/query';
import { GET_ORGANISATIONS_QUERY_KEY } from '../../constants/queryKeys';
import { getOrganisations } from '../candidate/account-management/api-services/api';

/** to get organisations
 * @returns KeyValueResponse[]
 * */
export const useGetOrganisationsQuery = (
  queryOptions?: UseQueryOptions<KeyValueResponse[], ServiceError> | undefined
) =>
  useCustomQuery<KeyValueResponse[]>(
    GET_ORGANISATIONS_QUERY_KEY,
    () => getOrganisations().then((res) => res.data),
    queryOptions,
    false,
    false
  );
